import { IMenuItem } from "@repo/core/components/layout/types";

export const HEADER_NAVIGATION_ITEMS: IMenuItem[] = [
  {
    key: "profile",
    action: "$navigate",
    icon: "circle-user",
    label: "Meu perfil",
    iconColor: "$secondary500",
    labelColor: "$secondary500"
  },
  /* {
    key: "support",
    action: "$navigate",
    icon: "circle-question",
    label: "Ajuda e Suporte",
    iconColor: "$secondary500",
    labelColor: "$secondary500"
  }, */
  {
    key: "log-out",
    action: "$custom",
    icon: "log-out",
    iconColor: "$error600",
    label: "Sair do app",
    labelColor: "$error600"
  }
];

export const SIDEBAR_NAVIGATION_ITEMS: IMenuItem[] = [
  { key: "home", action: "$navigate", icon: "home", label: "Home" },
  {
    key: "proposals",
    action: "$navigate",
    icon: "file-circle-check",
    label: "Propostas"
  },
  /*  {
    key: "sales",
    action: "$navigate",
    icon: "dollar-sign",
    label: "Vendas",
    permissions: PermissionsGroup.sales
  }, */
  /*   {
    key: "credit-table",
    action: "$navigate",
    icon: "hand-holding-dollar",
    label: "Mesa de Crédito"
  }, */
  {
    key: "drafts",
    action: "$navigate",
    icon: "file-pen",
    label: "Rascunhos"
  }
  /* {
    key: "reports",
    action: "$navigate",
    icon: "chart-line",
    label: "Relatórios"
  } */
];

export const MOBILE_MENU_ITEMS: IMenuItem[] = [
  {
    key: "drafts",
    action: "$navigate",
    icon: "file-pen",
    iconColor: "$primary700",
    label: "Rascunhos"
  },
  /* {
    key: "reports",
    action: "$navigate",
    icon: "chart-line",
    iconColor: "$primary700",
    label: "Relatórios"
  }, */
  {
    key: "(profile)",
    action: "$navigate",
    icon: "circle-user",
    label: "Meu perfil",
    iconColor: "$primary700"
  },
  /* {
    key: "support",
    action: "$navigate",
    icon: "circle-question",
    iconColor: "$primary700",
    label: "Ajuda e suporte"
  }, */
  {
    key: "log-out",
    action: "$custom",
    icon: "log-out",
    iconColor: "$error600",
    label: "Sair do app",
    labelColor: "$error600"
  }
];
export const MOBILE_RESPONSIVE_MENU_ITEMS: IMenuItem[] = [
  {
    key: "drafts",
    action: "$navigate",
    icon: "file-pen",
    iconColor: "$primary700",
    label: "Rascunhos"
  },
  /*  {
    key: "reports",
    action: "$navigate",
    icon: "chart-line",
    iconColor: "$primary700",
    label: "Relatórios"
  }, */
  {
    key: "profile",
    action: "$navigate",
    icon: "circle-user",
    label: "Meu perfil",
    iconColor: "$primary700"
  },
  /* {
    key: "support",
    action: "$navigate",
    icon: "circle-question",
    label: "Ajuda e Suporte",
    iconColor: "$primary700"
  }, */
  {
    key: "log-out",
    action: "$custom",
    icon: "log-out",
    iconColor: "$error600",
    label: "Sair do app",
    labelColor: "$error600"
  }
];

export const MOBILE_BOTTOM_BAR_ITEMS: IMenuItem[] = [
  {
    key: "home",
    action: "$navigate",
    icon: "home",
    label: "Home",
    isSelectable: true
  },
  {
    key: "proposals",
    action: "$navigate",
    icon: "file-circle-check",
    isSelectable: true,
    label: "Propostas"
  },
  /*  {
    key: "sales",
    action: "$navigate",
    icon: "dollar-sign",
    label: "Vendas",
    isSelectable: true,
    permissions: PermissionsGroup.sales
  }, */
  /* {
    key: "credit-table",
    action: "$navigate",
    icon: "hand-holding-dollar",
    isSelectable: true,
    label: "Mesa"
  }, */
  {
    key: "open-menu",
    action: "$custom",
    icon: "ellipsis",
    isSelectable: false,
    label: "Mais"
  }
];
